export default "__VITE_ASSET__ChgKJOPA__"